// Project-choose ("+") links are generated server-side without a
// project_folder_id, so they fall back to session[:last_project_folder_id]
// on the server. When the user has just clicked a different folder in the
// sidebar, the persist POST may not have committed before this click
// fires, and the add lands in the previous folder.
//
// This listener stamps the currently-active sidebar folder ID onto the
// link's URL at click time, so the controller can read it from params
// instead of relying on the session catching up.

document.addEventListener('click', (event) => {
  const link = event.target.closest('a.project-choose-link')
  if (!link) return

  const itemsSignalEl = document.querySelector('[data-controller~="project--items-signal"]')
  if (!itemsSignalEl) return

  const folderId = itemsSignalEl.getAttribute('data-project--items-signal-folder-id-value')
  if (!folderId) return

  try {
    const url = new URL(link.href, window.location.origin)
    url.searchParams.set('project_folder_id', folderId)
    link.href = url.toString()
  } catch (e) {
    // Invalid URL — leave the link alone.
  }
}, true) // capture phase so we run before Turbo's click handler
